/**
 * @generated SignedSource<<12ae3e5e52023f8060fcaaf02534a1a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VaultAccessDetails_assignVaultManagementGroup_Mutation$variables = {
  vaultId: string;
  vaultManagementGroupId: string;
};
export type VaultAccessDetails_assignVaultManagementGroup_Mutation$data = {
  readonly assignVaultManagementGroup: {
    readonly vaultUpdated: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"VaultAccessDetails_node">;
    };
  } | null;
};
export type VaultAccessDetails_assignVaultManagementGroup_Mutation = {
  response: VaultAccessDetails_assignVaultManagementGroup_Mutation$data;
  variables: VaultAccessDetails_assignVaultManagementGroup_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "vaultId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "vaultManagementGroupId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "vaultId",
        "variableName": "vaultId"
      },
      {
        "kind": "Variable",
        "name": "vaultManagementGroupId",
        "variableName": "vaultManagementGroupId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VaultAccessDetails_assignVaultManagementGroup_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VaultsAssignManagementGroupMutationPayload",
        "kind": "LinkedField",
        "name": "assignVaultManagementGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Vault",
            "kind": "LinkedField",
            "name": "vaultUpdated",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "VaultAccessDetails_node"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VaultAccessDetails_assignVaultManagementGroup_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VaultsAssignManagementGroupMutationPayload",
        "kind": "LinkedField",
        "name": "assignVaultManagementGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Vault",
            "kind": "LinkedField",
            "name": "vaultUpdated",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AuthorizationResult",
                "kind": "LinkedField",
                "name": "canUpdate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Member",
                "kind": "LinkedField",
                "name": "members",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "roles",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "VaultManagementGroup",
                "kind": "LinkedField",
                "name": "vaultManagementGroup",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberConnection",
                    "kind": "LinkedField",
                    "name": "managers",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Member",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6f6e2d3d091da2411958212332b413b5",
    "id": null,
    "metadata": {},
    "name": "VaultAccessDetails_assignVaultManagementGroup_Mutation",
    "operationKind": "mutation",
    "text": "mutation VaultAccessDetails_assignVaultManagementGroup_Mutation(\n  $vaultId: ID!\n  $vaultManagementGroupId: ID!\n) {\n  assignVaultManagementGroup(input: {vaultId: $vaultId, vaultManagementGroupId: $vaultManagementGroupId}) {\n    vaultUpdated {\n      id\n      ...VaultAccessDetails_node\n    }\n  }\n}\n\nfragment UserAvatar_member on Member {\n  name\n  email\n  avatar {\n    url\n  }\n}\n\nfragment UserHandle_member on Member {\n  id\n  name\n  email\n  ...UserAvatar_member\n  ...UserInfoPopover_member\n}\n\nfragment UserInfoPopover_member on Member {\n  id\n  name\n  email\n  roles\n  ...UserAvatar_member\n}\n\nfragment VaultAccessDetails_node on Vault {\n  id\n  canUpdate {\n    value\n  }\n  name\n  members {\n    id\n    name\n    ...UserHandle_member\n  }\n  vaultManagementGroup {\n    id\n    name\n    ...VaultManagementGroupLabel_vaultManagementGroup\n  }\n}\n\nfragment VaultManagementGroupLabel_vaultManagementGroup on VaultManagementGroup {\n  id\n  name\n  managers {\n    edges {\n      node {\n        id\n        ...UserAvatar_member\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b3106c3317a650d7662d7d4b1c37d1e2";

export default node;
